// extracted by mini-css-extract-plugin
export default {"search-mobile":"SearchMobile_search-mobile__207zo"};